import { Box, Container } from '@chakra-ui/react'
import React, { type ReactNode } from 'react'

interface ContentContainerProps {
  children: ReactNode
}

export const ContentContainer: React.FC<ContentContainerProps> = ({
  children
}) => {
  return (
    <Box flex="1" overflowX="hidden" overflowY="auto">
      <Container maxWidth="1206px">{children}</Container>
    </Box>
  )
}

export default ContentContainer
